import { gql } from '@apollo/client';

export const ITEM_QUERY = gql`
  query GetItem($id: ID!, $companyId: ID!) {
    company: Company(id: $companyId) {
      id
      modificationGroups {
        id
        externalName
        type
        required
        expandedByDefault
        preselectedVariations
        variations {
          id
          price
          name
          nameLang {
            id
            se
            en
            es
            no
          }

          allergen

          asItem {
            id
          }

          image {
            id
            file {
              id
              url
            }
          }
        }
      }
    }
    item: Item(id: $id) {
      id
      ageRestricted
      title
      vatRate
      disableMembershipDiscount
      categories {
        id
      }
      titleLang {
        id
        se
        en
        es
        no
      }
      description
      descriptionLang {
        id
        se
        en
        es
        no
      }
      modificationGroups
      sizes {
        id
        type
        variations {
          id
          price
          absolutePrice
          name
        }
      }
      image {
        id
        file {
          id
          url
        }
      }
      upsales {
        id
        hideInApp
        enableMultiSelect
        name {
          id
          se
          en
        }
        items {
          id
          disableMembershipDiscount
          vatRate
          titleLang {
            id
            se
            en
            es
            no
          }
          defaultPrice
          image {
            id
            file {
              id
              url
            }
          }
          categories {
            id
            name
            deleted
          }
        }
      }
      allergens
      allergyTags
    }
  }
`;
